var map = {
	"./01.svg": 1072,
	"./02.svg": 1073,
	"./03.svg": 1074,
	"./3in1.png": 1075,
	"./3yrreturns-icon.png": 1076,
	"./Exclamation-mark-red-icon.svg": 671,
	"./Fundscardsnew/Banner.png": 1077,
	"./Fundscardsnew/Banner2.png": 1078,
	"./Fundscardsnew/Large-cap-nfo-small-banner.png": 1079,
	"./Fundscardsnew/Motilal_Oswal_Nifty_Capital_Market_Index.png": 1080,
	"./Fundscardsnew/active-momentum-card-banner.png": 1081,
	"./Fundscardsnew/arrow_drop_down.png": 1082,
	"./Fundscardsnew/card-banner-budinesscycleNFO.png": 1083,
	"./Fundscardsnew/card-banner-manufacturingnfo.png": 1084,
	"./Fundscardsnew/card-consumption.png": 1085,
	"./Fundscardsnew/card-digital-india-nfo-banner.png": 1086,
	"./Fundscardsnew/card-finance.png": 1087,
	"./Fundscardsnew/card-healthcare.png": 1088,
	"./Fundscardsnew/card-it-telecom.png": 1089,
	"./Fundscardsnew/cardBanner.png": 1090,
	"./Fundscardsnew/dot_01.gif": 1091,
	"./Fundscardsnew/icGridview.jpg": 1092,
	"./Fundscardsnew/icListView.jpg": 1093,
	"./Fundscardsnew/ic_close.svg": 1094,
	"./Fundscardsnew/ic_dot.png": 1095,
	"./Fundscardsnew/icons8-pencil-14.png": 1096,
	"./Fundscardsnew/info-icon-blue.svg": 1097,
	"./Fundscardsnew/info-icon.jpg": 1098,
	"./Fundscardsnew/innovation-opp-nfo-card-banner-new.png": 1099,
	"./Fundscardsnew/minimize-risk-card.png": 1100,
	"./Fundscardsnew/multiCapfundCardBanner.png": 1101,
	"./Fundscardsnew/nifty-momentum-card-banner.png": 1102,
	"./Fundscardsnew/pencil.png": 1103,
	"./Homepage/Account Statment.png": 1104,
	"./Homepage/App Store.png": 1105,
	"./Homepage/Blog-1.png": 1106,
	"./Homepage/Blog-2.png": 1107,
	"./Homepage/Blog-3.png": 1108,
	"./Homepage/Blog-4.png": 1109,
	"./Homepage/Blogs.png": 1110,
	"./Homepage/Business Portfolio.png": 1111,
	"./Homepage/Car-Big.png": 1112,
	"./Homepage/Car-inner.png": 1113,
	"./Homepage/Downloads.png": 1114,
	"./Homepage/Education-Big.png": 1115,
	"./Homepage/Education-inner.png": 1116,
	"./Homepage/Equity-man.png": 1117,
	"./Homepage/Facebook.png": 1118,
	"./Homepage/Footer Arrow.png": 1119,
	"./Homepage/Group Sites.png": 1120,
	"./Homepage/Holiday-Big.png": 1121,
	"./Homepage/Holiday-inner.png": 1122,
	"./Homepage/House-Big.png": 1123,
	"./Homepage/House-Inner.png": 1124,
	"./Homepage/Investment-Background.png": 1125,
	"./Homepage/Logo.png": 1126,
	"./Homepage/Main-blog.png": 1127,
	"./Homepage/Map.png": 1128,
	"./Homepage/Money Plant.png": 1129,
	"./Homepage/Motilal Building.svg": 1130,
	"./Homepage/Multiple-girl.png": 1131,
	"./Homepage/NAV.png": 1132,
	"./Homepage/Newsletter Logo.png": 1133,
	"./Homepage/Next-trillion.png": 1134,
	"./Homepage/PiggyBank.png": 1135,
	"./Homepage/Play man.png": 1136,
	"./Homepage/Playstore Logo.png": 1137,
	"./Homepage/Plus-Icon.png": 1138,
	"./Homepage/Rectangle 4132.png": 1139,
	"./Homepage/Rectangle 4293.png": 1140,
	"./Homepage/TAX.png": 1141,
	"./Homepage/Tools.png": 1142,
	"./Homepage/Top Arrow.png": 1143,
	"./Homepage/Top Button Arrow.png": 1144,
	"./Homepage/Twitter.png": 1145,
	"./Homepage/Value Strategy.png": 1146,
	"./Homepage/Wedding-Big.png": 1147,
	"./Homepage/Wedding-inner.png": 1148,
	"./Homepage/Whatsapp Logo.png": 1149,
	"./Homepage/Youtube.png": 1150,
	"./Homepage/adult-banking-blur-1.png": 1151,
	"./Homepage/apple.png": 1152,
	"./Homepage/building.png": 1153,
	"./Homepage/cancel.png": 1154,
	"./Homepage/cart.png": 1155,
	"./Homepage/common-application-icon.svg": 1156,
	"./Homepage/compare-icon.svg": 1157,
	"./Homepage/compare-portfolio-default 1.png": 1158,
	"./Homepage/compare-portfolio-default.png": 1159,
	"./Homepage/compare-portfolio.png": 1160,
	"./Homepage/compounding-magic-default.png": 1161,
	"./Homepage/compounding-magic.png": 1162,
	"./Homepage/documents-icons.zip": 1163,
	"./Homepage/factsheet-icon.svg": 1164,
	"./Homepage/fundcard-bg.svg": 1165,
	"./Homepage/fundsize-icon.svg": 1166,
	"./Homepage/goal-calculator-default.png": 1167,
	"./Homepage/goal-calculator.png": 1168,
	"./Homepage/info-icon.svg": 1169,
	"./Homepage/investor logo.png": 1170,
	"./Homepage/key-man.svg": 1171,
	"./Homepage/leaflte-icon.svg": 1172,
	"./Homepage/mail.png": 1173,
	"./Homepage/minamt-icon.svg": 1174,
	"./Homepage/piggyBG.svg": 1175,
	"./Homepage/playstore.png": 1176,
	"./Homepage/presentation-icon.svg": 1177,
	"./Homepage/return-icon.svg": 1178,
	"./Homepage/right-arrow.png": 1179,
	"./Homepage/risk-icon.svg": 1180,
	"./Homepage/risk-veryhigh.png": 1181,
	"./Homepage/search.png": 1182,
	"./Homepage/share-icon.png": 1183,
	"./Homepage/sip-calculator-default.png": 1184,
	"./Homepage/sip-calculator.png": 1185,
	"./Homepage/smartphone.png": 1186,
	"./Homepage/taxBG.svg": 1187,
	"./Homepage/undraw_super_woman_dv0y.png": 1188,
	"./Homepage/user.png": 1189,
	"./Homepage/whatsapp.png": 1190,
	"./Index-fund-logo-old.png": 1191,
	"./Index-fund-logo.png": 1192,
	"./LAS.svg": 1193,
	"./Logo copy.png": 1194,
	"./MOTOS.png": 1195,
	"./SP500-Cloud-396x400.gif": 1196,
	"./about-sheme.png": 1197,
	"./about/aboutBG.jpg": 1198,
	"./about/abtres.png": 1199,
	"./about/abtres.svg": 1200,
	"./about/building.jpg": 1201,
	"./about/download.png": 1202,
	"./about/download.svg": 1203,
	"./about/focusbtn.svg": 1204,
	"./about/headingImage.png": 1205,
	"./about/investment.png": 1206,
	"./about/investment2.png": 1207,
	"./about/overview1.png": 1208,
	"./about/people.svg": 1209,
	"./about/ra-profile.jpg": 1210,
	"./about/star.svg": 1211,
	"./about/trust.png": 1212,
	"./abt-1.png": 1213,
	"./abt-2.png": 1214,
	"./abt-3.png": 1215,
	"./abt-4.png": 1216,
	"./account/accountBG.svg": 1217,
	"./account/accountstatement.svg": 1218,
	"./account/captcha.svg": 1219,
	"./account/greenRight.svg": 1220,
	"./appitite-icon.jpg": 1221,
	"./arrowleft.png": 1222,
	"./ascons-banner.png": 1223,
	"./b-riskometer-mh.png": 1224,
	"./bank.png": 1225,
	"./banner-curve.png": 1226,
	"./banner-midcap150.jpg": 1227,
	"./banner-thumb.png": 1228,
	"./bg-bluelines.jpg": 1229,
	"./blue-line.png": 1230,
	"./calender.svg": 1231,
	"./call-icon.png": 1232,
	"./cards-arrow-l.png": 1233,
	"./cards-arrow-r.png": 1234,
	"./cards-waves.png": 1235,
	"./cart-icon.png": 1236,
	"./cart/Ellipse 2112.svg": 1237,
	"./cart/Filters.png": 1238,
	"./cart/Group 134.png": 1239,
	"./cart/Group 7244.png": 1240,
	"./cart/Group 7553.png": 1241,
	"./cart/Group 9056.png": 1242,
	"./cart/Homepage/Account Statment.png": 1243,
	"./cart/Homepage/App Store.png": 1244,
	"./cart/Homepage/Blog-1.png": 1245,
	"./cart/Homepage/Blog-2.png": 1246,
	"./cart/Homepage/Blog-3.png": 1247,
	"./cart/Homepage/Blog-4.png": 1248,
	"./cart/Homepage/Blogs.png": 1249,
	"./cart/Homepage/Business Portfolio.png": 1250,
	"./cart/Homepage/Car-Big.png": 1251,
	"./cart/Homepage/Car-inner.png": 1252,
	"./cart/Homepage/Downloads.png": 1253,
	"./cart/Homepage/Education-Big.png": 1254,
	"./cart/Homepage/Education-inner.png": 1255,
	"./cart/Homepage/Equity-man.png": 1256,
	"./cart/Homepage/Facebook.png": 1257,
	"./cart/Homepage/Footer Arrow.png": 1258,
	"./cart/Homepage/Group Sites.png": 1259,
	"./cart/Homepage/Holiday-Big.png": 1260,
	"./cart/Homepage/Holiday-inner.png": 1261,
	"./cart/Homepage/House-Big.png": 1262,
	"./cart/Homepage/House-Inner.png": 1263,
	"./cart/Homepage/Investment-Background.png": 1264,
	"./cart/Homepage/Logo.png": 1265,
	"./cart/Homepage/Main-blog.png": 1266,
	"./cart/Homepage/Map.png": 1267,
	"./cart/Homepage/Money Plant.png": 1268,
	"./cart/Homepage/Motilal Building.svg": 1269,
	"./cart/Homepage/Multiple-girl.png": 1270,
	"./cart/Homepage/NAV.png": 1271,
	"./cart/Homepage/Newsletter Logo.png": 1272,
	"./cart/Homepage/Next-trillion.png": 1273,
	"./cart/Homepage/PiggyBank.png": 1274,
	"./cart/Homepage/Play man.png": 1275,
	"./cart/Homepage/Playstore Logo.png": 1276,
	"./cart/Homepage/Plus-Icon.png": 1277,
	"./cart/Homepage/Rectangle 4132.png": 1278,
	"./cart/Homepage/Rectangle 4293.png": 1279,
	"./cart/Homepage/TAX.png": 1280,
	"./cart/Homepage/Tools.png": 1281,
	"./cart/Homepage/Top Arrow.png": 1282,
	"./cart/Homepage/Top Button Arrow.png": 1283,
	"./cart/Homepage/Twitter.png": 1284,
	"./cart/Homepage/Value Strategy.png": 1285,
	"./cart/Homepage/Wedding-Big.png": 1286,
	"./cart/Homepage/Wedding-inner.png": 1287,
	"./cart/Homepage/Whatsapp Logo.png": 1288,
	"./cart/Homepage/Youtube.png": 1289,
	"./cart/Homepage/adult-banking-blur-1.png": 1290,
	"./cart/Homepage/apple.png": 1291,
	"./cart/Homepage/building.png": 1292,
	"./cart/Homepage/cancel.png": 1293,
	"./cart/Homepage/cart.png": 1294,
	"./cart/Homepage/common-application-icon.svg": 1295,
	"./cart/Homepage/compare-icon.svg": 1296,
	"./cart/Homepage/compare-portfolio-default 1.png": 1297,
	"./cart/Homepage/compare-portfolio-default.png": 1298,
	"./cart/Homepage/compare-portfolio.png": 1299,
	"./cart/Homepage/compounding-magic-default.png": 1300,
	"./cart/Homepage/compounding-magic.png": 1301,
	"./cart/Homepage/factsheet-icon.svg": 1302,
	"./cart/Homepage/fundcard-bg.svg": 1303,
	"./cart/Homepage/fundsize-icon.svg": 1304,
	"./cart/Homepage/goal-calculator-default.png": 1305,
	"./cart/Homepage/goal-calculator.png": 1306,
	"./cart/Homepage/info-icon.svg": 1307,
	"./cart/Homepage/investor logo.png": 1308,
	"./cart/Homepage/key-man.svg": 1309,
	"./cart/Homepage/leaflte-icon.svg": 1310,
	"./cart/Homepage/mail.png": 1311,
	"./cart/Homepage/minamt-icon.svg": 1312,
	"./cart/Homepage/piggyBG.svg": 1313,
	"./cart/Homepage/playstore.png": 1314,
	"./cart/Homepage/presentation-icon.svg": 1315,
	"./cart/Homepage/return-icon.svg": 1316,
	"./cart/Homepage/right-arrow.png": 1317,
	"./cart/Homepage/risk-icon.svg": 1318,
	"./cart/Homepage/risk-veryhigh.png": 1319,
	"./cart/Homepage/search.png": 1320,
	"./cart/Homepage/share-icon.png": 1321,
	"./cart/Homepage/sip-calculator-default.png": 1322,
	"./cart/Homepage/sip-calculator.png": 1323,
	"./cart/Homepage/smartphone.png": 1324,
	"./cart/Homepage/taxBG.svg": 1325,
	"./cart/Homepage/undraw_super_woman_dv0y.png": 1326,
	"./cart/Homepage/user.png": 1327,
	"./cart/Homepage/whatsapp.png": 1328,
	"./cart/Money Flag.png": 1329,
	"./cart/Rectangle 3362.png": 1330,
	"./cart/Shake Hand.png": 1331,
	"./cart/accept.png": 1332,
	"./cart/addAcc.svg": 1333,
	"./cart/arrow_back.png": 1334,
	"./cart/arrowleft.png": 1335,
	"./cart/bob.png": 1336,
	"./cart/c1.png": 1337,
	"./cart/calendar_icon.svg": 1338,
	"./cart/card-sip-icon.svg": 1339,
	"./cart/card_lumpsum_icon.svg": 1340,
	"./cart/cart_dnf.svg": 1341,
	"./cart/close_icon.svg": 1342,
	"./cart/e1.svg": 1343,
	"./cart/e2.svg": 1344,
	"./cart/e3.svg": 1345,
	"./cart/e4.svg": 1346,
	"./cart/f1.png": 1347,
	"./cart/faq.svg": 1348,
	"./cart/female-icon.png": 1349,
	"./cart/fofBG.svg": 1350,
	"./cart/fofIcon.svg": 1351,
	"./cart/fund_icon.png": 1352,
	"./cart/greenRight.svg": 1353,
	"./cart/holding_icon.svg": 1354,
	"./cart/hourse.svg": 1355,
	"./cart/icons8-ok-64.svg": 1356,
	"./cart/info.png": 1357,
	"./cart/investment/Group 8534.jpg": 1358,
	"./cart/investment/Group 8534@2x.jpg": 1359,
	"./cart/investment/calender.svg": 1360,
	"./cart/investment/female.svg": 1361,
	"./cart/investment/leftBG.svg": 1362,
	"./cart/investment/leftbg.jpg": 1363,
	"./cart/investment/lumsum.svg": 1364,
	"./cart/investment/male.svg": 1365,
	"./cart/investment/red.svg": 1366,
	"./cart/investment/rightbg.svg": 1367,
	"./cart/investment/sip.svg": 1368,
	"./cart/investment/switch.svg": 1369,
	"./cart/investment/upload.svg": 1370,
	"./cart/key1.jpg": 1371,
	"./cart/key2.jpg": 1372,
	"./cart/key3.jpg": 1373,
	"./cart/keyimg.jpg": 1374,
	"./cart/lock.svg": 1375,
	"./cart/loginpeople.svg": 1376,
	"./cart/low_icon.png": 1377,
	"./cart/m1.png": 1378,
	"./cart/m2.png": 1379,
	"./cart/male-icon.png": 1380,
	"./cart/media.jpg": 1381,
	"./cart/mens.png": 1382,
	"./cart/mens.svg": 1383,
	"./cart/mfDetailbg.svg": 1384,
	"./cart/mftimeline.svg": 1385,
	"./cart/mgBG.svg": 1386,
	"./cart/minus_icon.svg": 1387,
	"./cart/noun_locked lock_1010538.svg": 1388,
	"./cart/overview1.png": 1389,
	"./cart/p1.png": 1390,
	"./cart/playicon.svg": 1391,
	"./cart/plus_icon.svg": 1392,
	"./cart/popup_side_img.svg": 1393,
	"./cart/postlogin/authentication-icon.svg": 1394,
	"./cart/postlogin/bank-icon.svg": 1395,
	"./cart/postlogin/bitcoin.svg": 1396,
	"./cart/postlogin/boost-btn-icon.png": 1397,
	"./cart/postlogin/broker-error-icon.svg": 1398,
	"./cart/postlogin/broker-icon.svg": 1399,
	"./cart/postlogin/broker-success-icon.svg": 1400,
	"./cart/postlogin/call-icon.svg": 1401,
	"./cart/postlogin/cancel (2).svg": 1402,
	"./cart/postlogin/card-add-to-cart-icon.svg": 1403,
	"./cart/postlogin/card-lumpsum-icon.svg": 1404,
	"./cart/postlogin/card-sip-icon.svg": 1405,
	"./cart/postlogin/cart-icon.svg": 1406,
	"./cart/postlogin/carttable-infoicon.svg": 1407,
	"./cart/postlogin/cashflow-checkout-icon.svg": 1408,
	"./cart/postlogin/cheque-icon.svg": 1409,
	"./cart/postlogin/delete-icon.svg": 1410,
	"./cart/postlogin/direct-ribbon.svg": 1411,
	"./cart/postlogin/edit-icon.svg": 1412,
	"./cart/postlogin/elss-fund.gif": 1413,
	"./cart/postlogin/email-icon.svg": 1414,
	"./cart/postlogin/error-table-icon.svg": 1415,
	"./cart/postlogin/exit-load-icon.svg": 1416,
	"./cart/postlogin/facebook-logo.svg": 1417,
	"./cart/postlogin/filter-icon.svg": 1418,
	"./cart/postlogin/folio-icon.svg": 1419,
	"./cart/postlogin/folio-joint.svg": 1420,
	"./cart/postlogin/folio-minor.svg": 1421,
	"./cart/postlogin/folio-single.svg": 1422,
	"./cart/postlogin/footer-blue-bg.svg": 1423,
	"./cart/postlogin/footer-chatwithus-icon.svg": 1424,
	"./cart/postlogin/footer-faqs-icon.svg": 1425,
	"./cart/postlogin/footer-searchlocation-icon.svg": 1426,
	"./cart/postlogin/footer-whatsapp-icon.svg": 1427,
	"./cart/postlogin/greenarrow-icon.svg": 1428,
	"./cart/postlogin/greentick-icon.svg": 1429,
	"./cart/postlogin/grid-icon.svg": 1430,
	"./cart/postlogin/index-funds.gif": 1431,
	"./cart/postlogin/info-icon.svg": 1432,
	"./cart/postlogin/infobig-icon.svg": 1433,
	"./cart/postlogin/instagram-logo.svg": 1434,
	"./cart/postlogin/internationalBG.jpg": 1435,
	"./cart/postlogin/list-icon.svg": 1436,
	"./cart/postlogin/loader-logo.svg": 1437,
	"./cart/postlogin/main-clip.svg": 1438,
	"./cart/postlogin/mandate-homepage-banner.jpg": 1439,
	"./cart/postlogin/mandate-icon.svg": 1440,
	"./cart/postlogin/mastercard-icon.svg": 1441,
	"./cart/postlogin/money-bag.svg": 1442,
	"./cart/postlogin/more-vertical.svg": 1443,
	"./cart/postlogin/multiasset-balancing-mob-banner.jpg": 1444,
	"./cart/postlogin/neft-rtgs-icon.svg": 1445,
	"./cart/postlogin/neftrtgs-icon.svg": 1446,
	"./cart/postlogin/net-banking-icon.svg": 1447,
	"./cart/postlogin/netbanking-otm-icon.svg": 1448,
	"./cart/postlogin/order-icon.svg": 1449,
	"./cart/postlogin/otm-mandate-mob.jpg": 1450,
	"./cart/postlogin/payment-fail.svg": 1451,
	"./cart/postlogin/payment-method-icon.svg": 1452,
	"./cart/postlogin/payment-success.svg": 1453,
	"./cart/postlogin/payment-summary-icon.svg": 1454,
	"./cart/postlogin/payment-waiting.svg": 1455,
	"./cart/postlogin/pms-homepage-mob-banner.jpg": 1456,
	"./cart/postlogin/profit.svg": 1457,
	"./cart/postlogin/redamount-icon.svg": 1458,
	"./cart/postlogin/redarrow-icon.svg": 1459,
	"./cart/postlogin/redemption-icon.svg": 1460,
	"./cart/postlogin/regular-ribbon.svg": 1461,
	"./cart/postlogin/review-checkout-icon.svg": 1462,
	"./cart/postlogin/rupee-sign.svg": 1463,
	"./cart/postlogin/schedule-sip-icon.svg": 1464,
	"./cart/postlogin/search-icon.svg": 1465,
	"./cart/postlogin/sip-error-icon.svg": 1466,
	"./cart/postlogin/sip-shubh-aarambh-mob-banner.jpg": 1467,
	"./cart/postlogin/sipmenu-bank.svg": 1468,
	"./cart/postlogin/sipmenu-cancel.svg": 1469,
	"./cart/postlogin/sipmenu-feedback.svg": 1470,
	"./cart/postlogin/sipmenu-pause.svg": 1471,
	"./cart/postlogin/sipmenu-statement.svg": 1472,
	"./cart/postlogin/small-clip.svg": 1473,
	"./cart/postlogin/stp-icon.svg": 1474,
	"./cart/postlogin/swp-icon.svg": 1475,
	"./cart/postlogin/tax-icon.svg": 1476,
	"./cart/postlogin/thank-you.png": 1477,
	"./cart/postlogin/twitter-logo.svg": 1478,
	"./cart/postlogin/upi-icon.svg": 1479,
	"./cart/postlogin/whatsapp-banner.jpg": 1480,
	"./cart/postlogin/x-circle.svg": 1481,
	"./cart/postlogin/youtube-logo.svg": 1482,
	"./cart/rightCheck.svg": 1483,
	"./cart/rightarrow.svg": 1484,
	"./cart/rupeesBg.svg": 1485,
	"./cart/rupeesIcon.svg": 1486,
	"./cart/sbi.png": 1487,
	"./cart/searchbar.svg": 1488,
	"./cart/sip_info_icon.svg": 1489,
	"./cart/tagmsg.svg": 1490,
	"./cart/taxBG.svg": 1491,
	"./cart/taxIcon.svg": 1492,
	"./cart/transgender-icon.png": 1493,
	"./cart/v1.svg": 1494,
	"./cart/v2.svg": 1495,
	"./cart/v3.svg": 1496,
	"./cart/v4.svg": 1497,
	"./cart/v5.svg": 1498,
	"./cart/v6.svg": 1499,
	"./cart/v7.svg": 1500,
	"./cart/yellowcolor.png": 1501,
	"./cart/yellowcolor2x.png": 1502,
	"./cashflow/background1.png": 1503,
	"./cashflow/background1.svg": 1504,
	"./cashflow/background2.png": 1505,
	"./cashflow/background2.svg": 1506,
	"./cashflow/background3.png": 1507,
	"./cashflow/background3.svg": 1508,
	"./cashflow/background4.png": 1509,
	"./cashflow/background4.svg": 1510,
	"./cashflow/banner_chart.svg": 1511,
	"./cashflow/bannerbg.png": 1512,
	"./cashflow/bannerbg.svg": 1513,
	"./cashflow/cashflow_icon1.svg": 1514,
	"./cashflow/cashflow_icon2.svg": 1515,
	"./cashflow/cashflow_icon3.svg": 1516,
	"./cashflow/cashflow_icon4.svg": 1517,
	"./cashflow/cashflowplan_graphic.svg": 1518,
	"./cashflow/introcashplan.svg": 1519,
	"./category/BannerMultiCapNfo.png": 1520,
	"./category/HT-AS.svg": 1521,
	"./category/HT-minor.svg": 1522,
	"./category/HT-single.svg": 1523,
	"./category/NFO_PostLogin_MidSmall_Finacial_Services_Hero_desktop.jpg": 1524,
	"./category/active-momentum-checkout-banner-mob.png": 1525,
	"./category/active-momentum-checkout-banner-web.png": 1526,
	"./category/addedcart-icon.svg": 1527,
	"./category/addtocart-icon.svg": 1528,
	"./category/banner-consumption-comp.jpg": 1529,
	"./category/banner-consumption-mobile-comp.jpg": 1530,
	"./category/banner-finance-comp.jpg": 1531,
	"./category/banner-finance-mobile-comp.jpg": 1532,
	"./category/banner-healthcare-comp.jpg": 1533,
	"./category/banner-healthcare-mobile-comp.jpg": 1534,
	"./category/banner-it-telecom-comp.jpg": 1535,
	"./category/banner-it-telecom-mobile-comp.jpg": 1536,
	"./category/banner.PNG": 1537,
	"./category/businesscycle-nfo-banner.png": 1538,
	"./category/calendar_icon.svg": 1539,
	"./category/card-banner-budinesscycle_NFO.png": 1540,
	"./category/card-lumpsum-icon.svg": 1541,
	"./category/card-sip-icon.svg": 1542,
	"./category/curved-arrow-right.svg": 1543,
	"./category/curved-arrow.svg": 1544,
	"./category/defence-nfo-quickbuy-banner.png": 1545,
	"./category/digital-india-nfo-banner.png": 1546,
	"./category/fund-size-icon.svg": 1547,
	"./category/fundcard-bg.svg": 1548,
	"./category/fundsize-icon.svg": 1549,
	"./category/grid-icon.svg": 1550,
	"./category/info-icon copy.svg": 1551,
	"./category/info-icon-outline.svg": 1552,
	"./category/info-icon.svg": 1553,
	"./category/innovation-switch-mob-rebrand.jpg": 1554,
	"./category/innovation-switch-web-rebrand.jpg": 1555,
	"./category/list-icon.svg": 1556,
	"./category/manufacturing-nfo-banner.png": 1557,
	"./category/mi-filter.svg": 1558,
	"./category/min-amount.svg": 1559,
	"./category/minamt-icon.svg": 1560,
	"./category/nfo-banner-consumption-comp-mobile.jpg": 1561,
	"./category/nfo-banner-consumption-comp.jpg": 1562,
	"./category/nfo-banner-finance-comp-mobile.jpg": 1563,
	"./category/nfo-banner-finance-comp.jpg": 1564,
	"./category/nfo-banner-healthcare-comp-mobile.jpg": 1565,
	"./category/nfo-banner-healthcare-comp.jpg": 1566,
	"./category/nfo-banner-it-telecom-comp-mobile.jpg": 1567,
	"./category/nfo-banner-it-telecom-comp.jpg": 1568,
	"./category/nfo_postlogin_arbitage_banner_desk.jpg": 1569,
	"./category/nfo_postlogin_arbitage_banner_mob.png": 1570,
	"./category/nifty-500-momentum-banner.png": 1571,
	"./category/nifty-momentum-Banner.png": 1572,
	"./category/nifty500Momentum.png": 1573,
	"./category/no-mandate-icon.svg": 1574,
	"./category/qb_cancel_icon.svg": 1575,
	"./category/qb_mod_icon.svg": 1576,
	"./category/qb_remove_item.svg": 1577,
	"./category/return-icon.svg": 1578,
	"./category/risk-icon.svg": 1579,
	"./category/risk-veryhigh.png": 1580,
	"./category/riskometer-icon.svg": 1581,
	"./category/search-icon.svg": 1582,
	"./category/shopping-bag.svg": 1583,
	"./category/slide1.png": 1584,
	"./category/sortBy.svg": 1585,
	"./chart1.svg": 1586,
	"./check-list-icon.svg": 1587,
	"./check-list.png": 1588,
	"./check-list.svg": 1589,
	"./check-shadow.svg": 1590,
	"./check.svg": 1591,
	"./close.png": 675,
	"./common-inner-nfo-banner-mob.png": 1592,
	"./common-inner-nfo-banner.png": 1593,
	"./comparison-icon.png": 1594,
	"./contact/Map.png": 1595,
	"./contact/building.svg": 1596,
	"./contact/building_icon.png": 1597,
	"./contact/mail.png": 1598,
	"./contact/smartphone.png": 1599,
	"./contact/user.png": 1600,
	"./contactus-banner.jpg": 1601,
	"./crisis-icon.png": 1602,
	"./dash/404_error.svg": 1603,
	"./dash/accountstmt.svg": 1604,
	"./dash/annualreturn.png": 1605,
	"./dash/banner.svg": 1606,
	"./dash/bar.svg": 1607,
	"./dash/basket-buy-banner.gif": 1608,
	"./dash/buymore.svg": 1609,
	"./dash/calVec.svg": 1610,
	"./dash/coin-light.svg": 1611,
	"./dash/coin.svg": 1612,
	"./dash/currentvalue.png": 1613,
	"./dash/dailygain.png": 1614,
	"./dash/dash.svg": 1615,
	"./dash/green.svg": 1616,
	"./dash/investment.png": 1617,
	"./dash/latestActive.svg": 1618,
	"./dash/minus.svg": 1619,
	"./dash/nfo-popup/Mob-responsive-720x540-px_gold-and-silver-NFO.jpeg": 1620,
	"./dash/nfo-popup/conclave-event.jpeg": 1621,
	"./dash/nfo-popup/enhanced-popup-banner.jpeg": 1622,
	"./dash/nfo-popup/quality-popup-banner.jpeg": 1623,
	"./dash/orderbook.svg": 1624,
	"./dash/plus.svg": 1625,
	"./dash/portfolio-dnf-icon.svg": 1626,
	"./dash/portfolioview.png": 1627,
	"./dash/red.svg": 1628,
	"./dash/redem.svg": 1629,
	"./dash/scheduletrans.svg": 1630,
	"./dash/sipUp.svg": 1631,
	"./dash/totalInvestment.png": 1632,
	"./dash/totalgain.png": 1633,
	"./dash/transhis.svg": 1634,
	"./dash/upcomming.svg": 1635,
	"./dash/zbp_folio_creation_icon.svg": 1636,
	"./dash/zbp_make_payment_icon.svg": 1637,
	"./dash/zbp_select_fund_icon.svg": 1638,
	"./dash/zero_balance_portfolio.svg": 1639,
	"./dash/zero_balance_steps_icon.svg": 1640,
	"./diversified-icon.jpg": 1641,
	"./dollarhedge-graph.png": 1642,
	"./downlo-tab-icons.png": 1643,
	"./download-icons-01.png": 1644,
	"./download-icons-02.png": 1645,
	"./download-icons-03.png": 1646,
	"./download-icons-04.png": 1647,
	"./download-icons-05.png": 1648,
	"./download-icons-06 - Copy.png": 1649,
	"./download-icons-06.png": 1650,
	"./download/Edit.svg": 1651,
	"./download/banner.svg": 1652,
	"./download/close.svg": 1653,
	"./download/cloud.svg": 1654,
	"./download/email.svg": 1655,
	"./download/pdf.png": 1656,
	"./download/view.svg": 1657,
	"./download/whatsapp.svg": 1658,
	"./download/xls.png": 1659,
	"./downloadnav-icon.png": 1660,
	"./dtl-man.png": 1661,
	"./dynamic-fund-coffee-desbanner.jpg": 1662,
	"./dynamic-fund-coffee-mobbanner.jpg": 1663,
	"./e-mandate-success-icon.png": 676,
	"./email-icon.png": 1664,
	"./emandate-inprocess.svg": 684,
	"./equity-banner-inner-mob.jpg": 1665,
	"./equity-banner-inner.jpg": 1666,
	"./equity-banner-mob.jpg": 1667,
	"./equity-banner.jpg": 1668,
	"./exclaimation_yellow.png": 1669,
	"./existinguser.svg": 1670,
	"./eye.svg": 1671,
	"./f25-banner-mob.jpg": 1672,
	"./f25-banner.jpg": 1673,
	"./f25-starbull.png": 1674,
	"./f500-valuation-graph1.jpg": 1675,
	"./fab-background.png": 1676,
	"./fab-logo.png": 1677,
	"./fabPlan/calImagePopUp.png": 1678,
	"./fabPlan/calImagePopUp2X.png": 1679,
	"./fabPlan/fab-background.png": 1680,
	"./fabPlan/fab-background_11zon.png": 1681,
	"./fabPlan/fab-logo.png": 1682,
	"./fabPlan/fab-logo@2x.png": 1683,
	"./fabPlan/gold.png": 1684,
	"./fabPlan/idea_fab_plan.png": 1685,
	"./fabPlan/info-icon.svg": 1686,
	"./fabPlan/info-icon2.svg": 1687,
	"./fabPlan/info-icon3.svg": 1688,
	"./fabPlan/loading.svg": 1689,
	"./fabPlan/order-summary-icon.svg": 1690,
	"./fabPlan/pause-process.png": 1691,
	"./fabPlan/pencil-blue.svg": 1692,
	"./fabPlan/pencil.svg": 1693,
	"./fabPlan/recommended-icon.png": 1694,
	"./fabPlan/ribbon-strip.png": 1695,
	"./fabPlan/small-calendar-2.svg": 1696,
	"./fabPlan/small-calendar.svg": 1697,
	"./fabPlan/statistics.png": 1698,
	"./fabPlan/tablet-active.png": 1699,
	"./fabPlan/thankyou-page-banner.svg": 1700,
	"./fabPlan/thumbs-up.png": 1701,
	"./failed-mandate-icon.png": 677,
	"./faq-banner-thumb.png": 1702,
	"./faq-etf.png": 1703,
	"./faq-icon.png": 1704,
	"./faq-icon.svg": 1705,
	"./faq-man-woman.png": 1706,
	"./faq.jpg": 1707,
	"./faq/faq.svg": 1708,
	"./faq/searchbar.svg": 1709,
	"./favicon-index.png": 1710,
	"./favicon.png": 1711,
	"./fbank-indices.jpg": 1712,
	"./fbank-valuation-graph1.jpg": 1713,
	"./features-points-01-th.jpg": 1714,
	"./features-points-01.jpg": 1715,
	"./features-points-02-th.png": 1716,
	"./features-points-02.png": 1717,
	"./features-points-03.png": 1718,
	"./feedback-img.png": 1719,
	"./flower-etf.png": 1720,
	"./footer-blue-bg.bad4f86f.svg": 1721,
	"./footer/appstore.png": 1722,
	"./footer/appstore_mobile.png": 1723,
	"./footer/arrow_down_thin.png": 1724,
	"./footer/arrow_up_filled.png": 1725,
	"./footer/background.png": 1726,
	"./footer/call.png": 1727,
	"./footer/facebook.png": 1728,
	"./footer/instagram.png": 1729,
	"./footer/linkedin.png": 1730,
	"./footer/mail.png": 1731,
	"./footer/mo_mf_logo.svg": 1732,
	"./footer/playstore.png": 1733,
	"./footer/playstore_mobile.png": 1734,
	"./footer/whatsapp.png": 1735,
	"./footer/x.png": 1736,
	"./footer/youtube.png": 1737,
	"./fund150-banner.jpg": 1738,
	"./fundIcon/MHR.svg": 1739,
	"./fundIcon/fofBG.svg": 1740,
	"./fundIcon/fofIcon.svg": 1741,
	"./fundIcon/growth_icon.svg": 1742,
	"./fundIcon/growth_icon1.svg": 1743,
	"./fundIcon/growth_icon3.svg": 1744,
	"./fundIcon/pencil.svg": 1745,
	"./fundIcon/rupeesBg.svg": 1746,
	"./fundIcon/rupeesIcon.svg": 1747,
	"./fundIcon/taxBG.svg": 1748,
	"./fundIcon/taxIcon.svg": 1749,
	"./globalexposure-graph.png": 1750,
	"./greenRight.svg": 1751,
	"./half-circle.png": 1752,
	"./header/appstore_mobile_black.png": 1753,
	"./header/arrow_down_thin.svg": 1754,
	"./header/arrow_right.png": 1755,
	"./header/become-distributor_new.svg": 1756,
	"./header/close.png": 1757,
	"./header/commodity.svg": 1758,
	"./header/debt_and_liquid.svg": 1759,
	"./header/downloads_new.svg": 1760,
	"./header/dropdown-arrow.svg": 1761,
	"./header/etf.svg": 1762,
	"./header/faq_new.svg": 1763,
	"./header/fund_icon.png": 1764,
	"./header/hybrid_and_balanced.svg": 1765,
	"./header/index_fund.svg": 1766,
	"./header/indian_equity.svg": 1767,
	"./header/international_equity.svg": 1768,
	"./header/login_new.svg": 1769,
	"./header/mobile_menu.png": 1770,
	"./header/multi_asset.svg": 1771,
	"./header/nfo_beacon.gif": 1772,
	"./header/phone.png": 1773,
	"./header/phone_red.png": 1774,
	"./header/playstore_mobile_black.png": 1775,
	"./header/quick_purchase_new.svg": 1776,
	"./header/why_choose_us_new.svg": 1777,
	"./higherdividend-graph.png": 1778,
	"./historic-performace-gsec-fof.png": 1779,
	"./historic-performace.png": 1780,
	"./home-indexfunds.png": 1781,
	"./home/Blog-1.png": 1782,
	"./home/Blog-2.png": 1783,
	"./home/Blog-3.png": 1784,
	"./home/Blog-4.png": 1785,
	"./home/Equity-man.png": 1786,
	"./home/Investment-Background.png": 1787,
	"./home/Main-blog.png": 1788,
	"./home/Multiple-girl.png": 1789,
	"./home/Playman.png": 1790,
	"./home/account_statement.png": 1791,
	"./home/apple.png": 1792,
	"./home/banner1.svg": 1793,
	"./home/blog.png": 1794,
	"./home/cashflow-home.png": 1795,
	"./home/circle-bg.png": 1796,
	"./home/download.png": 1797,
	"./home/elss-shark-banner-desktop.jpg": 1798,
	"./home/elss-shark-banner-mob.jpg": 1799,
	"./home/f25-focus-banner-desktop.jpg": 1800,
	"./home/f25-product-focus-banner-mob.jpg": 1801,
	"./home/headingImage-red.png": 1802,
	"./home/investment-philosophy.jpg": 1803,
	"./home/investorlogo.png": 1804,
	"./home/key-man.svg": 1805,
	"./home/mandate-icon.png": 1806,
	"./home/mfwhatsapp.png": 1807,
	"./home/minimalinv-banner-desktop.jpg": 1808,
	"./home/minimalinv-banner-mob.jpg": 1809,
	"./home/moviindex-home.png": 1810,
	"./home/multi-and-dynamic-cake-banner-desktop.jpg": 1811,
	"./home/multi-and-dynamic-cake-banner-mob.jpg": 1812,
	"./home/nav.png": 1813,
	"./home/playstore.png": 1814,
	"./home/ques.png": 1815,
	"./home/quick-invest.png": 1816,
	"./home/shortblast-home.png": 1817,
	"./home/sipbooster-home.png": 1818,
	"./home/small-is-powerful-banner-desktop.jpg": 1819,
	"./home/small-is-powerful-earth-banner-mob.jpg": 1820,
	"./home/smartmockups_jzwdpybx.png": 1821,
	"./home/tools.png": 1822,
	"./home/whatsapp.png": 1823,
	"./how-asset-allocation.png": 1824,
	"./icon-1.png": 125,
	"./icon-2.png": 301,
	"./icon-3.png": 126,
	"./icon-unclaimred.png": 1825,
	"./index-fund-banners-2-xs.png": 1826,
	"./index-fund-banners-2.png": 1827,
	"./index-fund-banners-3-xs.png": 1828,
	"./index-fund-banners-3.png": 1829,
	"./index-fund-banners-4-xs.png": 1830,
	"./index-fund-banners-4.png": 1831,
	"./index-fund-banners-xs.png": 1832,
	"./index-fund-banners.png": 1833,
	"./index-fund-icons-d-cl.png": 1834,
	"./index-fund-icons-growth-cl.png": 1835,
	"./index-fund-icons-low-cl.png": 1836,
	"./index-fund-icons-risk-cl.png": 1837,
	"./index-fund-icons-trans-cl.png": 1838,
	"./index-icon1.png": 1839,
	"./index-icon11.png": 1840,
	"./index-icon2.png": 1841,
	"./index-icon22.png": 1842,
	"./index-icon3.png": 1843,
	"./index-icon33.png": 1844,
	"./index-icon4.png": 1845,
	"./index-icon44.png": 1846,
	"./index-icon5.png": 1847,
	"./index-icon55.png": 1848,
	"./indexlist-arrow-inner.png": 1849,
	"./indexlist-arrow.png": 1850,
	"./indian-market-cloud.png": 1851,
	"./info-gray.svg": 719,
	"./info.png": 1852,
	"./info.svg": 1853,
	"./inndex-fund-small-midcap-mob.jpg": 1854,
	"./inndex-fund-small-midcap.jpg": 1855,
	"./instant-sip-icon.png": 1856,
	"./international/internationalBG.jpg": 1857,
	"./international/key1.png": 1858,
	"./international/key2.png": 1859,
	"./international/key3.png": 1860,
	"./international/mens.jpg": 1861,
	"./international/tag.png": 1862,
	"./intersetialBigImg.svg": 1863,
	"./investment/Cross-icon.svg": 1864,
	"./investment/Group 8534.jpg": 1865,
	"./investment/Group 8534@2x.jpg": 1866,
	"./investment/boost-btn-icon.png": 1867,
	"./investment/calender.svg": 1868,
	"./investment/female.svg": 1869,
	"./investment/filter-icon.svg": 1870,
	"./investment/leftBG.svg": 1871,
	"./investment/leftbg.jpg": 1872,
	"./investment/lumsum.svg": 1873,
	"./investment/male.svg": 1874,
	"./investment/order-icon.svg": 1875,
	"./investment/red.svg": 1876,
	"./investment/rightbg.svg": 1877,
	"./investment/schedule-sip-icon.svg": 1878,
	"./investment/sip-boosted.png": 1879,
	"./investment/sip.svg": 1880,
	"./investment/sipmenu-bank.svg": 1881,
	"./investment/sipmenu-cancel.svg": 1882,
	"./investment/sipmenu-feedback.svg": 1883,
	"./investment/sipmenu-pause.svg": 1884,
	"./investment/sipmenu-statement.svg": 1885,
	"./investment/small-clip.svg": 1886,
	"./investment/switch.svg": 1887,
	"./investment/upload.svg": 1888,
	"./investment/x-circle.svg": 1889,
	"./invobj-tab-icon-w.png": 1890,
	"./invobj-tab-icon.png": 1891,
	"./isip.svg": 1892,
	"./kimform-icon.svg": 1893,
	"./kyc/thank-you.png": 1894,
	"./landing/MHR.svg": 1895,
	"./landing/PMS-BG.svg": 1896,
	"./landing/diverse-portfolio-w.png": 1897,
	"./landing/fofBG.svg": 1898,
	"./landing/fofIcon.svg": 1899,
	"./landing/growth_icon.svg": 1900,
	"./landing/growth_icon1.svg": 1901,
	"./landing/growth_icon3.svg": 1902,
	"./landing/hourse.svg": 1903,
	"./landing/key1.jpg": 1904,
	"./landing/key2.jpg": 1905,
	"./landing/key3.jpg": 1906,
	"./landing/keyimg.jpg": 1907,
	"./landing/m1.png": 1908,
	"./landing/m2.png": 1909,
	"./landing/m3.png": 1910,
	"./landing/m4.png": 1911,
	"./landing/m5.png": 1912,
	"./landing/mgBG.svg": 1913,
	"./landing/p1.png": 1914,
	"./landing/p2.png": 1915,
	"./landing/p3.png": 1916,
	"./landing/p4.png": 1917,
	"./landing/p5.png": 1918,
	"./landing/passBGbottom.svg": 1919,
	"./landing/playicon.svg": 1920,
	"./landing/pms1.png": 1921,
	"./landing/pms2.png": 1922,
	"./landing/pms3.png": 1923,
	"./landing/pms4.png": 1924,
	"./landing/professional-management-w.png": 1925,
	"./landing/rightarrow.svg": 1926,
	"./landing/rupeesBg.svg": 1927,
	"./landing/rupeesIcon.svg": 1928,
	"./landing/safe-transperent-w.png": 1929,
	"./landing/tax-saving-w.png": 1930,
	"./landing/taxBG.svg": 1931,
	"./landing/taxIcon.svg": 1932,
	"./large-grows.png": 1933,
	"./leaflate-icon.svg": 1934,
	"./leftBG.svg": 1935,
	"./leftbg.jpg": 1936,
	"./level2-seperator.png": 1937,
	"./level5-seperator.png": 1938,
	"./line.png": 1939,
	"./list-arrow-inner.png": 1940,
	"./list-arrow.png": 1941,
	"./listing/Mask Group 31.svg": 1942,
	"./listing/P_M_R.svg": 1943,
	"./listing/Rectangle 4184.svg": 1944,
	"./listing/bg_pms.svg": 1945,
	"./listing/charttest.svg": 1946,
	"./listing/d.png": 1947,
	"./listing/db_small.png": 1948,
	"./listing/e1.svg": 1949,
	"./listing/e2.svg": 1950,
	"./listing/e3.svg": 1951,
	"./listing/e4.svg": 1952,
	"./listing/investmentp.svg": 1953,
	"./listing/l1.png": 1954,
	"./listing/lt.png": 1955,
	"./listing/mens.png": 1956,
	"./listing/mens.svg": 1957,
	"./listing/mfDetailbg.svg": 1958,
	"./listing/p1.png": 1959,
	"./listing/p2.png": 1960,
	"./listing/p_icon1.svg": 1961,
	"./listing/pms-startegy-banner.png": 1962,
	"./listing/pmsBG.svg": 1963,
	"./listing/pms_v1.png": 1964,
	"./listing/pms_v10.png": 1965,
	"./listing/pms_v2.png": 1966,
	"./listing/pms_v3.png": 1967,
	"./listing/pms_v4.png": 1968,
	"./listing/pms_v5.png": 1969,
	"./listing/pms_v6.png": 1970,
	"./listing/pms_v7.png": 1971,
	"./listing/pms_v8.png": 1972,
	"./listing/pms_v9.png": 1973,
	"./listing/pmsbottom.svg": 1974,
	"./listing/po.png": 1975,
	"./listing/portolifo_left.svg": 1976,
	"./listing/portolifo_right.svg": 1977,
	"./listing/r1.png": 1978,
	"./listing/r_small.png": 1979,
	"./listing/red_pdf.svg": 1980,
	"./listing/tr.png": 1981,
	"./listing/v1.svg": 1982,
	"./listing/v10.svg": 1983,
	"./listing/v11.svg": 1984,
	"./listing/v12.svg": 1985,
	"./listing/v13.svg": 1986,
	"./listing/v14.svg": 1987,
	"./listing/v2.svg": 1988,
	"./listing/v3.svg": 1989,
	"./listing/v4.svg": 1990,
	"./listing/v5.svg": 1991,
	"./listing/v6.svg": 1992,
	"./listing/v7.svg": 1993,
	"./listing/v9.svg": 1994,
	"./listing/why1.png": 1995,
	"./listing/why2.png": 1996,
	"./listing/why3.png": 1997,
	"./listing/why4.png": 1998,
	"./lock.svg": 1999,
	"./lockpwd.png": 2000,
	"./login-etf-banner.svg": 2001,
	"./login-image.png": 720,
	"./login/300x250-01.gif": 2002,
	"./login/Factor-momentum-Money-control_New.gif": 2003,
	"./login/Flexicap-Fund-Banner.gif": 2004,
	"./login/Info-icon-yellow.svg": 2005,
	"./login/Large-Cap-Fund-passcode-banner.jpg": 2006,
	"./login/Website-Passcode-Banner-new.jpg": 2007,
	"./login/Website-Passcode-Banner.jpg": 2008,
	"./login/arbitrage-fund-passcode.jpg": 2009,
	"./login/badaIndex.gif": 2010,
	"./login/cancel_icon.png": 2011,
	"./login/check_icon.png": 2012,
	"./login/checked.png": 685,
	"./login/city_icon.png": 2013,
	"./login/digital-fund-passcode-hq.gif": 2014,
	"./login/email_icon.png": 2015,
	"./login/gold_passcode.jpg": 2016,
	"./login/grow_more.png": 2017,
	"./login/grow_more_label_line.png": 2018,
	"./login/imc-gif.gif": 2019,
	"./login/kyc_verify_icon.png": 2020,
	"./login/microcapNFO.gif": 2021,
	"./login/mo-brand.gif": 2022,
	"./login/mobile_icon.png": 2023,
	"./login/nfonew.jpg": 2024,
	"./login/nifty-capital-market.jpg": 2025,
	"./login/pan_icon.png": 2026,
	"./login/pan_name_icon.png": 2027,
	"./login/password_icon.png": 2028,
	"./login/pbanner.gif": 2029,
	"./login/pbanner_old.gif": 2030,
	"./login/show_password_icon.png": 2031,
	"./login/smallCap.gif": 2032,
	"./loginpeople.svg": 2033,
	"./logo-dark-groww.83f43714.svg": 2034,
	"./logo-dit.png": 2035,
	"./logo-mfbrst.png": 2036,
	"./logo-mo-amc.png": 679,
	"./logo-mo-amc2.png": 680,
	"./logo.png": 2037,
	"./logo.svg": 2038,
	"./logout.png": 2039,
	"./lowcost-icon.jpg": 2040,
	"./lumpsum-icon.png": 2041,
	"./maa-diversify-banner.png": 2042,
	"./manageBank/edit_icon.svg": 2043,
	"./manageBank/icon_bank.svg": 2044,
	"./manageBank/nominee/close_icon.svg": 2045,
	"./manageBank/nominee/nomDeleteIcon.svg": 2046,
	"./manageBank/nominee/nomEditIcon.svg": 2047,
	"./manageBank/nominee/nomineeNoteIcon.svg": 2048,
	"./manageBank/nominee/nomineeSuccessIcon.svg": 2049,
	"./manageBank/nominee_icon.svg": 2050,
	"./manageBank/notestyle.png": 2051,
	"./manageBank/success.svg": 2052,
	"./mid-grows.png": 2053,
	"./midcap150-1st.png": 2054,
	"./midcap150-valuation-graph1.jpg": 2055,
	"./midcap150-valuation-graph2.jpg": 2056,
	"./minimalist-banner.png": 2057,
	"./minus.png": 2058,
	"./mo-icon.png": 2059,
	"./mosl-brst-logo.png": 2060,
	"./movipack/Capture.png": 2061,
	"./movipack/about_icon1.svg": 2062,
	"./movipack/about_icon1hover.svg": 2063,
	"./movipack/about_icon2.svg": 2064,
	"./movipack/about_icon2hover.svg": 2065,
	"./movipack/about_icon3.svg": 2066,
	"./movipack/about_icon3hover.svg": 2067,
	"./movipack/about_icon4.svg": 2068,
	"./movipack/about_icon4hover.svg": 2069,
	"./movipack/about_icon5.svg": 2070,
	"./movipack/about_icon5hover.svg": 2071,
	"./movipack/background1.png": 2072,
	"./movipack/background2.png": 2073,
	"./movipack/bannerbg.png": 2074,
	"./movipack/calender.svg": 2075,
	"./movipack/dividendyeiled.svg": 2076,
	"./movipack/graphp.svg": 2077,
	"./movipack/icon_rupee.svg": 2078,
	"./movipack/movi_banner_graph.png": 2079,
	"./movipack/moviepack_why.png": 2080,
	"./movipack/movipack_feature1.svg": 2081,
	"./movipack/movipack_feature1hover.svg": 2082,
	"./movipack/movipack_feature2.svg": 2083,
	"./movipack/movipack_feature2hover.svg": 2084,
	"./movipack/movipack_feature3.svg": 2085,
	"./movipack/movipack_feature3hover.svg": 2086,
	"./movipack/movipack_feature4.svg": 2087,
	"./movipack/movipack_feature4hover.svg": 2088,
	"./movipack/movipack_feature5.svg": 2089,
	"./movipack/movipack_feature5hover.svg": 2090,
	"./movipack/phylosophy.png": 2091,
	"./movipack/phylosophytwo.svg": 2092,
	"./movipack/riskometer_high.png": 2093,
	"./movipack/riskometer_low.png": 2094,
	"./movipack/xls.png": 2095,
	"./multi-asset-fund-weather-mobbanner.jpg": 2096,
	"./multi-asset-weather-desbanner.jpg": 2097,
	"./multiasset-balancing-mob.jpg": 2098,
	"./multiasset-balancing.jpg": 2099,
	"./multiasset-banner-invest.jpg": 2100,
	"./multiasset-banner-mob-invest.jpg": 2101,
	"./multiasset-banner-mob.jpg": 2102,
	"./multiasset-banner-single.jpg": 2103,
	"./multiasset-banner.jpg": 2104,
	"./n500-icon.png": 2105,
	"./nav/Group 253.svg": 2106,
	"./nav/aldemat_navicon-light.svg": 2107,
	"./nav/aldemat_navicon.svg": 2108,
	"./nav/cart.svg": 2109,
	"./nav/goalbase_navicon-light.svg": 2110,
	"./nav/goalbase_navicon.svg": 2111,
	"./nav/icon_LAS-hover.svg": 2112,
	"./nav/icon_LAS.svg": 2113,
	"./nav/invest_navicon-light.svg": 2114,
	"./nav/invest_navicon.svg": 2115,
	"./nav/logo-momf.png": 2116,
	"./nav/manageac_navicon-light.svg": 2117,
	"./nav/manageac_navicon.svg": 2118,
	"./nav/managepr_navicon-light.svg": 2119,
	"./nav/managepr_navicon.svg": 2120,
	"./nav/menu.png": 2121,
	"./nav/mf-amc-brst-logo.png": 2122,
	"./nav/mf-m-min-logo.svg": 2123,
	"./nav/mf-new-logo.png": 2124,
	"./nav/mnschedule_navicon-light.svg": 2125,
	"./nav/mnschedule_navicon.svg": 2126,
	"./nav/moamc-mf-logo-new.png": 2127,
	"./nav/myportfolio_navicon-light.svg": 2128,
	"./nav/myportfolio_navicon.svg": 2129,
	"./nav/navBanner.svg": 2130,
	"./nav/navicon-othertransaction.svg": 2131,
	"./nav/navicon_siphouse_sip.svg": 2132,
	"./nav/orderbook_navicon-light.svg": 2133,
	"./nav/orderbook_navicon.svg": 2134,
	"./nav/profile-icon.png": 2135,
	"./nav/redemption_navicon-light.svg": 2136,
	"./nav/redemption_navicon.svg": 2137,
	"./nav/report_navicon-light.svg": 2138,
	"./nav/report_navicon.svg": 2139,
	"./nav/smartplan_navicon-light.svg": 2140,
	"./nav/smartplan_navicon.svg": 2141,
	"./nav/transfer_navicon-light.svg": 2142,
	"./nav/transfer_navicon.svg": 2143,
	"./nbank-icon.png": 2144,
	"./newuser.svg": 2145,
	"./nfo-closed-img.png": 2146,
	"./nfo-date-close.png": 2147,
	"./nfo-date-etf.png": 2148,
	"./nfo-date.png": 2149,
	"./nfo-n50-banner.png": 2150,
	"./nfo-navicon.svg": 2151,
	"./nfoBasket/ic_dot.png": 2152,
	"./nifty50-stocks-survived-graph.png": 2153,
	"./nifty50-survivorship-outperformance-graph.png": 2154,
	"./nifty50-whythisshift-graph.jpg": 2155,
	"./nifty50-whythisshift-graph2.jpg": 2156,
	"./nifty50-whythisshift-points.png": 2157,
	"./niftynext50-stocks-survived-graph.png": 2158,
	"./niftynext50-survivorship-outperformance-graph.png": 2159,
	"./nm150-icon.png": 2160,
	"./ns250-icon.png": 2161,
	"./onboarding/attachmentIcon.svg": 2162,
	"./onboarding/closeIcon.svg": 2163,
	"./onboarding/deleteIcon.svg": 2164,
	"./onboarding/female-icon.png": 2165,
	"./onboarding/male-icon.png": 2166,
	"./onboarding/nomineeFamilyIcon.svg": 2167,
	"./onboarding/transgender-icon.png": 2168,
	"./onboarding/uploadIcon.svg": 2169,
	"./option_icon.png": 2170,
	"./passive-fund-info.jpg": 2171,
	"./payment/info-icon.svg": 2172,
	"./payment/mastercard-icon.svg": 2173,
	"./payment/neft-rtgs-icon.svg": 2174,
	"./payment/net-banking-icon.svg": 2175,
	"./payment/payment-method-icon.svg": 2176,
	"./payment/upi-icon.svg": 2177,
	"./perfor-tab-icon.png": 2178,
	"./performanceglobalindices-graph.png": 2179,
	"./performancestrategy-fofac.png": 2180,
	"./plusicon.png": 2181,
	"./pms/BusinessPortfolio.png": 2182,
	"./pms/DedicatedRMs.png": 2183,
	"./pms/EqualityPortfolioGirl.svg": 2184,
	"./pms/IndiaOpportunityV1.png": 2185,
	"./pms/IndiaOpportunityV2.png": 2186,
	"./pms/Linkedinlogo.png": 2187,
	"./pms/Next-trillion.png": 2188,
	"./pms/PMS-Tree.svg": 2189,
	"./pms/PerformanceChart.png": 2190,
	"./pms/RaamdeoAggarwal.png": 2191,
	"./pms/RequestDeskGirl.svg": 2192,
	"./pms/RightWave.png": 2193,
	"./pms/Segregatedportfolios.png": 2194,
	"./pms/Telephone.png": 2195,
	"./pms/Transparency.png": 2196,
	"./pms/ValueStrategy.png": 2197,
	"./pms/pdf_download_icon.png": 681,
	"./portfo-tab-icon.png": 2198,
	"./postlogin/12_PMS_Reports_Fees Payable.jpg": 2199,
	"./postlogin/Group 26759.svg": 2200,
	"./postlogin/Path 20089.jpg": 2201,
	"./postlogin/addedcart-icon.svg": 2202,
	"./postlogin/addtocart-icon.svg": 2203,
	"./postlogin/authentication-icon.svg": 2204,
	"./postlogin/average-icon.svg": 2205,
	"./postlogin/bank-icon.svg": 2206,
	"./postlogin/bitcoin.svg": 2207,
	"./postlogin/boost-btn-icon.png": 2208,
	"./postlogin/broker-error-icon.svg": 2209,
	"./postlogin/broker-icon.svg": 2210,
	"./postlogin/call-icon.svg": 2211,
	"./postlogin/cancel (2).svg": 2212,
	"./postlogin/cant-say-icon.svg": 2213,
	"./postlogin/card-add-to-cart-icon.svg": 2214,
	"./postlogin/card-lumpsum-icon.svg": 2215,
	"./postlogin/card-sip-icon.svg": 2216,
	"./postlogin/cart-icon.svg": 2217,
	"./postlogin/cart-review-edit.jpg": 2218,
	"./postlogin/carttable-infoicon.svg": 2219,
	"./postlogin/cashflow-checkout-icon.svg": 2220,
	"./postlogin/cd-icon-arrow-next.svg": 2221,
	"./postlogin/cd-icon-select.svg": 2222,
	"./postlogin/cd-icons-cart-close.svg": 2223,
	"./postlogin/cheque-icon.svg": 2224,
	"./postlogin/delete-icon.svg": 2225,
	"./postlogin/direct-ribbon.svg": 2226,
	"./postlogin/edit-icon.svg": 2227,
	"./postlogin/elss-fund.gif": 2228,
	"./postlogin/email-icon.svg": 2229,
	"./postlogin/error-table-icon.svg": 2230,
	"./postlogin/existinguser.svg": 2231,
	"./postlogin/exit-load-icon.svg": 2232,
	"./postlogin/facebook-logo.svg": 2233,
	"./postlogin/filter-icon.svg": 2234,
	"./postlogin/folio-icon.svg": 2235,
	"./postlogin/folio-joint.svg": 2236,
	"./postlogin/folio-minor.svg": 2237,
	"./postlogin/folio-single.svg": 2238,
	"./postlogin/footer-blue-bg.svg": 2239,
	"./postlogin/footer-chatwithus-icon.svg": 2240,
	"./postlogin/footer-faqs-icon.svg": 2241,
	"./postlogin/footer-searchlocation-icon.svg": 2242,
	"./postlogin/footer-whatsapp-icon.svg": 2243,
	"./postlogin/good-icon.svg": 2244,
	"./postlogin/greenarrow-icon.svg": 2245,
	"./postlogin/greentick-icon.svg": 2246,
	"./postlogin/grid-icon.svg": 2247,
	"./postlogin/index-funds.gif": 2248,
	"./postlogin/info-icon.svg": 2249,
	"./postlogin/infobig-icon.svg": 2250,
	"./postlogin/instagram-logo.svg": 2251,
	"./postlogin/internationalBG.jpg": 2252,
	"./postlogin/list-icon.svg": 2253,
	"./postlogin/loader-logo.svg": 2254,
	"./postlogin/main-clip.svg": 2255,
	"./postlogin/mandate-homepage-banner.jpg": 2256,
	"./postlogin/mandate-icon.svg": 2257,
	"./postlogin/mastercard-icon.svg": 2258,
	"./postlogin/money-bag.svg": 2259,
	"./postlogin/more-vertical.svg": 2260,
	"./postlogin/multiasset-balancing-mob-banner.jpg": 2261,
	"./postlogin/neft-rtgs-icon.svg": 2262,
	"./postlogin/neftrtgs-icon.svg": 2263,
	"./postlogin/net-banking-icon.svg": 2264,
	"./postlogin/netbanking-otm-icon.svg": 2265,
	"./postlogin/newuser.svg": 2266,
	"./postlogin/order-icon.svg": 2267,
	"./postlogin/otm-mandate-mob.jpg": 2268,
	"./postlogin/payment-fail.svg": 2269,
	"./postlogin/payment-method-icon.svg": 2270,
	"./postlogin/payment-success.svg": 2271,
	"./postlogin/payment-summary-icon.svg": 2272,
	"./postlogin/payment-waiting.svg": 2273,
	"./postlogin/pms-homepage-mob-banner.jpg": 2274,
	"./postlogin/poor-icon.svg": 2275,
	"./postlogin/portfolio-details-section.svg": 2276,
	"./postlogin/product-preview.png": 2277,
	"./postlogin/profit.svg": 2278,
	"./postlogin/redamount-icon.svg": 2279,
	"./postlogin/redarrow-icon.svg": 2280,
	"./postlogin/redemption-icon.svg": 2281,
	"./postlogin/regular-ribbon.svg": 2282,
	"./postlogin/review-checkout-icon.svg": 2283,
	"./postlogin/rupee-sign.svg": 2284,
	"./postlogin/schedule-sip-icon.svg": 2285,
	"./postlogin/search-icon.svg": 2286,
	"./postlogin/sip-error-icon.svg": 2287,
	"./postlogin/sip-shubh-aarambh-mob-banner.jpg": 2288,
	"./postlogin/sipmenu-bank.svg": 2289,
	"./postlogin/sipmenu-cancel.svg": 2290,
	"./postlogin/sipmenu-feedback.svg": 2291,
	"./postlogin/sipmenu-pause.svg": 2292,
	"./postlogin/sipmenu-statement.svg": 2293,
	"./postlogin/small-clip.svg": 2294,
	"./postlogin/stp-icon.svg": 2295,
	"./postlogin/swp-icon.svg": 2296,
	"./postlogin/tax-icon.svg": 2297,
	"./postlogin/thank-you.png": 2298,
	"./postlogin/topblock-section.svg": 2299,
	"./postlogin/twitter-logo.svg": 2300,
	"./postlogin/upi-icon.svg": 2301,
	"./postlogin/ver-poor-icon.svg": 2302,
	"./postlogin/very-good-icon.svg": 2303,
	"./postlogin/whatsapp-banner.jpg": 2304,
	"./postlogin/x-circle.svg": 2305,
	"./postlogin/youtube-logo.svg": 2306,
	"./prelogin-header/Logo.png": 2307,
	"./prelogin-header/basket-banner.gif": 2308,
	"./prelogin-header/cashflow-img.svg": 2309,
	"./prelogin-header/login-icon.svg": 2310,
	"./prelogin-header/login-lock.svg": 2311,
	"./prelogin-header/logo-mo-asset.png": 2312,
	"./prelogin-header/loudspeaker.png": 2313,
	"./prelogin-header/movi-img.svg": 2314,
	"./prelogin-header/nfo_beacon.gif": 2315,
	"./prelogin-header/quick-invest-icon.svg": 2316,
	"./presentation-icon.svg": 2317,
	"./produc-tab-icon.png": 2318,
	"./profile/ach_icon.png": 2319,
	"./profile/addprofile.svg": 2320,
	"./profile/bill_icon.png": 2321,
	"./profile/contact_icon.png": 2322,
	"./profile/fatca2_icon.png": 2323,
	"./profile/folio-icon.svg": 2324,
	"./profile/mandate_icon.png": 2325,
	"./profile/minus.png": 2326,
	"./profile/netbankg_icon.png": 2327,
	"./profile/nominee_icon.png": 2328,
	"./profile/plus.png": 2329,
	"./profile/profile_pic.png": 2330,
	"./profile/user_icon.png": 2331,
	"./reblancing-icon.jpg": 2332,
	"./reedem.svg": 2333,
	"./rightarrow.svg": 2334,
	"./rightbg.svg": 2335,
	"./risk-fofac-h.png": 2336,
	"./risk-fofac-vh.png": 2337,
	"./riskometer-h.png": 2338,
	"./riskometer-low.png": 2339,
	"./riskometer-m-gsec-fof.png": 2340,
	"./riskometer-mh-etf.png": 2341,
	"./riskometer-mh.png": 2342,
	"./riskometer-moderate.png": 2343,
	"./riskometer-moderately-high.png": 2344,
	"./riskometer-moderately-low.png": 2345,
	"./riskometer-very-high.png": 2346,
	"./riskometerH.png": 2347,
	"./riskreduction-icon.jpg": 2348,
	"./searchicon.png": 2349,
	"./services-bg-rev.png": 2350,
	"./services-bg.png": 2351,
	"./share-icon.png": 2352,
	"./sid-icon.svg": 2353,
	"./sip-icon.png": 2354,
	"./sip.svg": 2355,
	"./sipHouse/boosterImages/downEllipse.png": 2356,
	"./sipHouse/boosterImages/upEllipse.png": 2357,
	"./sipHouse/down_arrow.svg": 2358,
	"./sipHouse/enter_sip_amt_bg_desktop.png": 2359,
	"./sipHouse/failureCheckmark.png": 2360,
	"./sipHouse/failureDesktop_bg.png": 2361,
	"./sipHouse/failureMobile_bg.jpg": 2362,
	"./sipHouse/ic_info.png": 2363,
	"./sipHouse/lowerEcllipse.png": 2364,
	"./sipHouse/short-arrow.svg": 2365,
	"./sipHouse/successCheckmark.png": 2366,
	"./sipHouse/successDesktop_bg.png": 2367,
	"./sipHouse/successMobile_bg.png": 2368,
	"./sipHouse/thankyouBannerNewDesktop.png": 2369,
	"./sipHouse/thankyouBannerNewMobile.png": 2370,
	"./sipHouse/up_arrow.svg": 2371,
	"./sipHouse/upperEcllipse.png": 2372,
	"./sipbooster/banner_bline.svg": 2373,
	"./sipbooster/banner_graphic.png": 2374,
	"./sipbooster/banner_graphic.svg": 2375,
	"./sipbooster/banner_tringleimg.svg": 2376,
	"./sipbooster/benefits_automatesavingicon.svg": 2377,
	"./sipbooster/benefits_fastrackicon.svg": 2378,
	"./sipbooster/benefits_shadow.svg": 2379,
	"./sipbooster/benefits_simpleinv.svg": 2380,
	"./sipbooster/benefits_sipbooster_creatoricon.svg": 2381,
	"./sipbooster/benefits_sipbooster_investmenticon.svg": 2382,
	"./sipbooster/breakline.svg": 2383,
	"./sipbooster/calendericon.svg": 2384,
	"./sipbooster/coin_booster.svg": 2385,
	"./sipbooster/coin_icon.svg": 2386,
	"./sipbooster/dashed line.svg": 2387,
	"./sipbooster/faq_graphic.svg": 2388,
	"./sipbooster/growthinvestment_bar1.svg": 2389,
	"./sipbooster/growthinvestment_bar2.svg": 2390,
	"./sipbooster/growthinvestment_bar3.svg": 2391,
	"./sipbooster/growthinvestment_bar4.svg": 2392,
	"./sipbooster/icon_rupee.svg": 2393,
	"./sipbooster/infographic_MSA.svg": 2394,
	"./sipbooster/infographic_MSB.svg": 2395,
	"./sipbooster/invest-now.png": 2396,
	"./sipbooster/leftarrow.svg": 2397,
	"./sipbooster/rightarrow.svg": 2398,
	"./sipbooster/topbannerboarder.svg": 2399,
	"./sipperformace-icon.png": 2400,
	"./skin-in-the-game-banner-mob.jpg": 2401,
	"./skin-in-the-game-banner.jpg": 2402,
	"./slide1.png": 721,
	"./small-calendar-2.svg": 2403,
	"./small-calendar.svg": 2404,
	"./small-riskometer-h.png": 2405,
	"./small-riskometer-l.png": 2406,
	"./small-riskometer-mh.png": 2407,
	"./smallcap250-valuation-graph1.jpg": 2408,
	"./spindex-banner-inner-mob.jpg": 2409,
	"./spindex-banner-inner.jpg": 2410,
	"./spindex-banner-mob.jpg": 2411,
	"./spindex-banner.gif": 2412,
	"./spindex-banner.jpg": 2413,
	"./stability-growth.png": 2414,
	"./stp.svg": 2415,
	"./sub-img.png": 2416,
	"./sweet-spot-1-etf.png": 2417,
	"./sweet-spot-1-gsec-fof.png": 2418,
	"./sweet-spot-2-etf.png": 2419,
	"./sweet-spot-2-gsec-fof.png": 2420,
	"./swipe-icon.png": 2421,
	"./switch.svg": 2422,
	"./swp.svg": 2423,
	"./tab-icon-1y.png": 2424,
	"./tab-icon-2y.png": 2425,
	"./tab-icon-3y.png": 2426,
	"./tab-icon-4y.png": 2427,
	"./tab-icon-why1y.png": 2428,
	"./tax-returns-etf.png": 2429,
	"./tax-returns-gec-fof.png": 2430,
	"./taxef-icon.jpg": 2431,
	"./thank-you.png": 2432,
	"./the-right-mix-img.png": 2433,
	"./think-MO-line-1.png": 2434,
	"./thumbs-up.png": 2435,
	"./tnc/Plus.png": 2436,
	"./tnc/disclaimer.jpg": 2437,
	"./tnc/minus.png": 2438,
	"./tnc/terms.jpg": 2439,
	"./tnc/yellowcolor.png": 2440,
	"./tools/Car-Big.png": 2441,
	"./tools/Car-inner.png": 2442,
	"./tools/Education-Big.png": 2443,
	"./tools/Education-inner.png": 2444,
	"./tools/Holiday-Big.png": 2445,
	"./tools/Holiday-inner.png": 2446,
	"./tools/House-Big.png": 2447,
	"./tools/House-Inner.png": 2448,
	"./tools/Money Plant.png": 2449,
	"./tools/Wedding-Big.png": 2450,
	"./tools/Wedding-inner.png": 2451,
	"./tools/compare-portfolio-default.png": 2452,
	"./tools/compare-portfolio.png": 2453,
	"./tools/compounding-magic-default.png": 2454,
	"./tools/compounding-magic.png": 2455,
	"./tools/goal-calculator-default.png": 2456,
	"./tools/goal-calculator.png": 2457,
	"./tools/sip-calculator-default.png": 2458,
	"./tools/sip-calculator.png": 2459,
	"./topup-icon.png": 2460,
	"./trackorder/bannersection.jpg": 2461,
	"./trackorder/calender.svg": 2462,
	"./trackorder/filter-icon.svg": 2463,
	"./trackorder/graphics-noinfofound.png": 2464,
	"./trackorder/icon-unclaimred.png": 2465,
	"./trackorder/order-icon.svg": 2466,
	"./trackorder/order_book_dfn.svg": 2467,
	"./trackorder/small-clip.svg": 2468,
	"./trans/Group 8999.png": 2469,
	"./trans/Group 9000.png": 2470,
	"./trans/Rectangle 4355.png": 2471,
	"./trans/Rectangle 4356.png": 2472,
	"./trans/Vector Smart Object.svg": 2473,
	"./trans/addmoney.png": 2474,
	"./trans/authentication-icon.svg": 2475,
	"./trans/bank-icon.svg": 2476,
	"./trans/boost-icon.png": 2477,
	"./trans/broker-icon.svg": 2478,
	"./trans/cart-icon.svg": 2479,
	"./trans/cashflow_icon.svg": 2480,
	"./trans/dematFolioPopupIcon.svg": 2481,
	"./trans/exit-load-icon.svg": 2482,
	"./trans/folio-icon.svg": 2483,
	"./trans/greenarrow-icon.svg": 2484,
	"./trans/info-icon.svg": 2485,
	"./trans/infobig-icon.svg": 2486,
	"./trans/invest-fund-icon.svg": 2487,
	"./trans/isip-icon.svg": 2488,
	"./trans/isip.png": 2489,
	"./trans/main-clip.svg": 2490,
	"./trans/minus-icon.svg": 2491,
	"./trans/new-fund-icon.svg": 2492,
	"./trans/new-fund-side-img.svg": 2493,
	"./trans/pigybank.png": 2494,
	"./trans/plus-icon.svg": 2495,
	"./trans/redamount-icon.svg": 2496,
	"./trans/redarrow-icon.svg": 2497,
	"./trans/redemption-graph.png": 2498,
	"./trans/redemption-icon.svg": 2499,
	"./trans/redemtionthank.png": 2500,
	"./trans/sip-img.svg": 2501,
	"./trans/small-clip.svg": 2502,
	"./trans/stp-icon.svg": 2503,
	"./trans/stpdetailsicon.svg": 2504,
	"./trans/swp-icon.svg": 2505,
	"./trans/swp-img.svg": 2506,
	"./trans/tax-icon.svg": 2507,
	"./transResponse/elss-fund.gif": 2508,
	"./transResponse/index-funds.gif": 2509,
	"./transResponse/mandate-homepage-banner.jpg": 2510,
	"./transResponse/order-icon.svg": 2511,
	"./transResponse/otm-mandate-mob.jpg": 2512,
	"./transResponse/payment-success.svg": 2513,
	"./transResponse/pending-consent-icon.png": 2514,
	"./transResponse/pending-consent-icon.svg": 2515,
	"./transResponse/whatsapp-banner old.jpg": 2516,
	"./transResponse/whatsapp-banner.jpg": 2517,
	"./tri.png": 2518,
	"./us-market-cloud.png": 2519,
	"./user.png": 722,
	"./video-1.jpg": 2520,
	"./video-2.jpg": 2521,
	"./video-3.jpg": 2522,
	"./whatsapp-icon.gif": 2523,
	"./whatsapp_banner_headline_desktop.gif": 2524,
	"./whatsapp_banner_headline_mobile.gif": 2525,
	"./why-fund-icon.png": 2526,
	"./why-index-sec-left.png": 2527,
	"./wl-1.png": 2528,
	"./wl-1w.png": 2529,
	"./wl-2.png": 2530,
	"./wl-2w.png": 2531,
	"./wl-3.png": 2532,
	"./wl-3w.png": 2533,
	"./wl-4.png": 2534,
	"./wl-4w.png": 2535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1071;